module.exports = __webpack_public_path__ + "static/img/bg.7fa0041.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpeg
// module id = o6zb
// module chunks = 0